exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-action,h1,p{text-align:center}.page-action{margin-top:30px;width:100%}.page-action--item{display:inline-block;width:120px;height:30px;color:#fff;line-height:30px;background:#3f86ff;border:none;border-radius:5px;outline:none}.page-link{margin-top:50px}", ""]);

// exports
